import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '/styles/pstlandingpage.module.scss'
import CustomImage from "../CustomImage"; 
import { Button } from "react-bootstrap";
import Card from 'react-bootstrap/Card'

interface Props {
    associatingdata: any;
    title: any;
    subtitle: any;
    bgcolor: any;
}
const AssociatingWithKc: React.FC<Props> = ({ associatingdata, title, subtitle, bgcolor }) => {
    return (

        <div className={styles.association} style={{ backgroundColor: bgcolor || "#FFF1EF" }}>
            <Container>
                <Row className="text-center">
                    <div>
                        <h1>{title}</h1>
                        <h5 className="mb-4">{subtitle}</h5>
                    </div>
                </Row>
                <Row>
                    {
                        associatingdata.map((details: any) => {
                            return (
                                <div className={styles.mainCard}>
                                    <Card className={styles.custCard}>
                                        <Row>
                                            <Col xl={4} md={4} sm={4} xs={12} className={styles.imgDiv}>
                                                <CustomImage src={details?.sectionImageUrl || "/images/partners/dummy.svg"} width={300} height={250} alt={"dummy"} />
                                            </Col>
                                            <Col xl={8} md={8} sm={8} xs={12}>
                                                <Card.Body className={styles.cardBody}>
                                                    <h5 className="text-center">{details?.sectionTitle}</h5>
                                                    <div className={styles.mainDiv}>
                                                        {
                                                            details?.points?.length > 0 &&
                                                            details?.points?.map((text: any) => {
                                                                return (
                                                                    <div className={styles.div}>
                                                                        <Row>
                                                                            <Col xl={3} md={3} sm={4} xs={12}>
                                                                                <h6>{text?.label} </h6>
                                                                            </Col>
                                                                            <Col xl={9} md={9} sm={8} xs={12}> <p>{text?.value}</p></Col>
                                                                        </Row>

                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </Card.Body>
                                            </Col>
                                        </Row>
                                    </Card>
                                </div>
                            )
                        })
                    }

                </Row>
            </Container>
        </div >
    )
}
export default AssociatingWithKc;